module.exports = __webpack_public_path__ + "img/axe_3.a8694762.png";